function getMobileOrder(stats) {
  if (stats.length !== 4) return stats;
  return [stats[0], stats[2], stats[1], stats[3]];
}

function StatItem({ item, withDivider }) {
  return (
    <div className={`text-center ${withDivider ? "border-r-2 border-[#E4E6EC] px-[40px]" : ""}`}>
      <p className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884] text-[36px] leading-[100%] font-[700]">
        {item.value}
      </p>
      <p className="text-[#6A7282] text-[14px] leading-[140%] font-[400] mt-[6px]">{item.label}</p>
    </div>
  );
}

export default function SeoPageStats({ seoPage }) {
  const stats = seoPage?.stats;

  if (!stats?.length) return null;

  const mobileStats = getMobileOrder(stats);

  return (
    <section className="bg-[#F8FAFF]">
      <div className="py-[24px]">
        <div className="hidden md:flex justify-center items-center gap-[40px] max-w-[90%] mx-auto">
          {stats.map((item, index) => (
            <StatItem
              key={`${item.value}-${item.label}-${index}`}
              item={item}
              withDivider={index !== stats.length - 1}
            />
          ))}
        </div>

        <div className="md:hidden grid grid-cols-2 gap-[32px]">
          {mobileStats.map((item, index) => (
            <div key={`${item.value}-${item.label}-${index}`} className="text-center">
              <p className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884] text-[20px] leading-[100%] font-[700]">
                {item.value}
              </p>
              <p className="text-[#6A7282] text-[14px] leading-[140%] font-[400] mt-[6px]">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
